import RecruitIcon from "../../medias/images/recruit-icon.png";
import TraineeIcon from "../../medias/images/trainee-icon.png";
import ExplorerIcon from "../../medias/images/explorer-icon.png";
import ResearcherIcon from "../../medias/images/researcher-icon.png";
import CommanderIcon from "../../medias/images/commander-icon.png";
import PioneerIcon from "../../medias/images/pionner-icon.png";

export const ACHIEVEMENT_LEVELS = {
  recruit: {
    label: "Recruit",
    icon: RecruitIcon,
    color: "#4da6ff",
  },
  trainee: {
    label: "Trainee",
    icon: TraineeIcon,
    color: "#39c5f3",
  },
  explorer: {
    label: "Explorer",
    icon: ExplorerIcon,
    color: "#ff7a2f",
  },
  researcher: {
    label: "Researcher",
    icon: ResearcherIcon,
    color: "#b968e8",
  },
  commander: {
    label: "Commander",
    icon: CommanderIcon,
    color: "#ffc766",
  },
  pioneer: {
    label: "Pioneer",
    icon: PioneerIcon,
    color: "#ffad38",
  },
};

/**
 * Retorna a configuração correspondente ao nível do usuário.
 *
 * @param {string} level
 * @returns {{ label: string, icon: string, color: string } | null}
 */
export const getAchievementLevelConfig = (level) => {
  if (!level) {
    return null;
  }

  const normalizedLevel = String(level).trim().toLowerCase();

  return ACHIEVEMENT_LEVELS[normalizedLevel] ?? null;
};